import React, { useState, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { TablaResultados } from './TablaResultados';
import { ServicioHttp } from '../../../servicios/ServicioHttp';
import { ServicioObjetos } from '../../../servicios/ServicioObjetos';

export const TimbrarExcel = () => {
    const toast = useRef(null);
    const fileUploadRef = useRef(null);

    const [resultados, setResultados] = useState([]);

    const onUpload = (event) => {
        let files = event.files;
        var formData = new FormData();
        for (var i = 0; i < files.length; i++) {
            var xlsx = files[i];
            formData.append('archivos', xlsx);
        }

        ServicioHttp.consumirPostHttp('layout/procesar.json', formData).then(response => {
           


            if(response.data.error){
                toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.mensaje, life: 8000 });  
            }else{
                toast.current.show({ severity: 'info', summary: 'Éxito', detail: 'Xml(s) cargado(s) con éxito', life: 8000 });
            }
            
            fileUploadRef.current.clear();
            setResultados(response.data.lista);
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Existe un problema al enviar los xml al servidor', life: 8000 });
        });
    }

    const chooseOptions = { label: 'Elegir archivos', icon: 'pi pi-fw pi-plus' };
    const uploadOptions = { label: 'Subir', icon: 'pi pi-upload', className: 'p-button-success' };
    const cancelOptions = { label: 'Cancelar', icon: 'pi pi-times', className: 'p-button-danger' };


    return (
        <div>
            <div className="grid">
                <div className="col-12">
                    <Toast ref={toast}></Toast>
                    <div className="card">
                        <h5>Timbrar archivo Excel</h5>
                        <p>En esta sección usted podrá timbrar los archivos Excel.</p>
                        <h5>Elegir Archivos</h5>
                        <FileUpload ref={fileUploadRef} name="xmls[]" customUpload={true} uploadHandler={onUpload} multiple accept=".xlsx"
                            emptyTemplate={<p className="p-m-0">Arrastre y suelte los archivos aquí para cargarlos.</p>}
                            chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} />
                    </div>
                </div>
            </div >
            {!ServicioObjetos.esObjetoVacio(resultados) ? <TablaResultados resultados={resultados} /> : null}
        </div>

    );
}
